import React, { useEffect, useRef, useState } from "react";

const ControlBox = (props) => {
  const {
    students,
    setCategory,
    cycle_number,
    setCycle_number,
    setDept_name,
    department_list,
  } = props;

  // start cycle_count state
  const [cycle_count, setCycle_count] = useState(0);

  useEffect(() => {
    let count = [...students].sort((a, b) => a.cycle - b.cycle).at(-1).cycle;
    setCycle_count(count);
  }, [students]);

  // start arr_for_cycles_map state
  const [arr_for_cycles_map] = useState([]);
  arr_for_cycles_map.length = cycle_count;
  console.log(arr_for_cycles_map)
  // arr_for_cycles_map = [];
  let rounds = [
    "Round-1 Group-1 (Aug 2017 /Sep 2017)",
    "Round-2 Group-2,3 (Nov 2017 /Dec 2017)",
    "Round-3 Group-4 (Feb 2018 /Mar 2018)",
    "Round-4 Group-5,6 (Jul 2018 /Aug 2018)",
    "Round-5 Group-7,8 (Nov 2018 /Dec 2018)",
    "Round-6 Group-9,10 (Apr 2019 /May 2019)",
    "Round-7 Group-11,12 (Aug 2019 /Sep 2019)",
    "Round-8 Group-13,14 (Dec 2019 /Jan 2020)",
    "Round-9 Group-15,16 (May 2020 /Jun 2020)",
    "Round-10 Group-17,18,19 (Sep 2020 /Oct 2020)",
    "Round-11 Group-20,21 (Dec 2020 /Jan 2021)",
    "Round-12 Group-22,23 (Apr 2021 /May 2021)",
    "Round-13 Group-24,25 (Aug 2021 /Sep 2021)",
    "Round-14 Group-26,27 (Dec 2021 /Jan 2022)",
    "Round-15 Group-28,29 (Apr 2022 /May 2022)",
    "Round-16 Group-30,31 (Jul 2022 /Aug 2022)",
    "Round-17 Group-32,33 (Nov 2022 / Jan 2023)",
    "Round-18 Group-34,35 (Mar 2023 / May 2023)",
    "Round-19 Group-36,37 (Jul 2023 / Sep 2023)"
  ];
  arr_for_cycles_map.fill(1, 0, cycle_count);
  // arr_for_cycles_map = rounds.slice();
  console.log(arr_for_cycles_map);
  // start refs
  const by_all_ref = useRef();
  const by_cycle_ref = useRef();
  const by_dept_ref = useRef();

  const cycles_ref = useRef();
  const deartments_ref = useRef();

  // start functions
  function by_all_handle_click() {
    by_all_ref.current.classList.add("active");
    by_cycle_ref.current.classList.remove("active");
    by_dept_ref.current.classList.remove("active");
    cycles_ref.current.classList.add("hide");
    deartments_ref.current.classList.add("hide");
    setCategory("all");
  }

  function by_cycle_handle_click() {
    by_cycle_ref.current.classList.add("active");
    by_all_ref.current.classList.remove("active");
    by_dept_ref.current.classList.remove("active");
    cycles_ref.current.classList.remove("hide");
    deartments_ref.current.classList.add("hide");
    setCategory("cycle");
  }

  function by_dept_handle_click() {
    by_dept_ref.current.classList.add("active");
    by_all_ref.current.classList.remove("active");
    by_cycle_ref.current.classList.remove("active");
    cycles_ref.current.classList.add("hide");
    deartments_ref.current.classList.remove("hide");
    setCategory("departments");
  }

  return (
    <div className="control-box">
      <div className="container alum">
        {/* choose category all - cycles - department */}
        <div className="category">
          <div className="item by-all active" ref={by_all_ref}>
            <i
              className="fa fa-users"
              aria-hidden="true"
              onClick={by_all_handle_click}
            ></i>
            <span>All Alumni</span>
          </div>

          <div className="item by-cycle" ref={by_cycle_ref}>
            <i
              className="fa fa-graduation-cap"
              aria-hidden="true"
              onClick={by_cycle_handle_click}
            ></i>
            <span>By cycle</span>
          </div>

          <div className="item by-department" ref={by_dept_ref}>
            <i
              className="fa fa-folder-open"
              aria-hidden="true"
              onClick={by_dept_handle_click}
            ></i>
            <span>By Category</span>
          </div>
        </div>

        {/* choose cycle number */}
        <div className="cycles hide" ref={cycles_ref}>
          <div className="item">
            <select onChange={(e) => setCycle_number(e.target.value)}>
              {rounds.map((element, index) => {
                return (
                  <option value={index + 1} key={index}>
                    {element}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="item">
            <div className="cycle-number">
              <span> Round {cycle_number}</span> / {cycle_count}
            </div>
          </div>
        </div>

        {/* choose department */}
        <div className="departments hide" ref={deartments_ref}>
          <div className="item">
            <select onChange={(e) => setDept_name(e.target.value)}>
              {department_list.map((ele) => {
                return (
                  <option key={ele} value={ele}>
                    {ele}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControlBox;
